"use client";
import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";
import api from "../../utils/api";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import TicketDetails from "./TcketDetails";
import Select from 'react-select';


interface RFIDData {
  ticketNumber: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  totalMembers: string;
  ticketBookingId: number;
  ticketUniqueId: string;
  cardAssignId: number;
}

const TicketAssignForm: React.FC = () => {
  const [ticketNumber, setTicketNumber] = useState("");
  const [rfidData, setRfidData] = useState<RFIDData | null>(null);
  const [dateTime, setDateTime] = useState("");
  const [rfid, setRfid] = useState("");
  const [allrfid, setallrfid] = useState([]);
  const [error, setError] = useState<boolean>(false);
  // const [cardAmount, setCardAmount] = useState(0);
  const cardAmount = 0;
 const navigate = useNavigate();
  useEffect(() => {
    const now = new Date();
    setDateTime(now.toISOString().slice(0, 10));
  }, []);

  const options = allrfid
  .filter((item: any) => item.status === false)
  .map((item: any) => ({
    value: item.rfId,
    label: `${item.rfidCardUniqueNumber}`,
  }));

  const handleSubmit = async (e: React.FormEvent) => {
    if (!ticketNumber || !rfid || !dateTime) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Fields',
        text: 'Please fill in all required fields.',
      });
      return;
    }
    if(rfidData === null || rfidData?.ticketUniqueId === null || rfidData?.ticketUniqueId === undefined || rfidData?.ticketUniqueId === "") {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Ticket',
        text: 'Please scan a valid ticket.',
      });
      return;
    }
    if(rfidData?.customerMobileNumber === null || rfidData?.customerMobileNumber === undefined || rfidData?.customerMobileNumber === "") {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid RF-ID Card',
        text: 'Please select a valid RF-ID card.',
      });
      return;
    }
    e.preventDefault();
    // console.log({ ticketNumber, dateTime, rfid, cardAmount });
    const payload = {
            cardAssignId: 0,
            ticketRFIdRef: ticketNumber,
            cardAmount: cardAmount,
            cardAssignDate: dateTime,
            rfId: Number(rfid),
            status: true,
            payBy: JSON.parse(localStorage.getItem('user')!).userId,
        };
    
        try {
            const response = await api.post('/api/CardAssign/AddCardAssign', payload, {
              headers: {
                'Content-Type': 'application/json',
              }
            });
        
            if (response.status === 200 || response.status === 201) {
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'RF-ID Card assigned successfully.',
              }).then(() => {
                navigate(`${process.env.PUBLIC_URL}/card/all_card_assign`);
              });
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Unexpected Response',
                text: 'Please try again later.',
              });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: 'Something went wrong while assign RF-ID card.',
        });
        }
  };

  const boxStyle = {
    boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
    border: "1px solid #ddd",
    background: "#fff",
    borderRadius: "10px",
  };

  const GetAllRfid = async () => {
    const response = await api.get("/api/RFIDCardMaster/GetRFIDCardMaster");
    const data = response.data;
    setallrfid(data);
    // console.log(data);
  };

  useEffect(() => {
    GetAllRfid();
  }, []);

  const bookingDetails = async (value: string) => {
      // console.log("ticket id:", value);
      setTicketNumber(value);
      if(value.length === 12) {
        setError(false);
        try {
          const response = await api.get(`/api/TicketBooking/GetTicketBookingDetails?ticketuniqueId=${value}`);
          if (response.status !== 200) {
            setRfidData(null);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to fetch booking details. Please check the ticket ID.',
            });
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.data;
          setRfidData(data);
        } catch (error) {
          Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to fetch booking details. Please check the ticket ID.',
            });
          console.error('Error fetching booking data:');
          setRfidData(null);
        }
      } else {
        setRfidData(null);
        setError(true);
        if(value.length > 12) {
          Swal.fire({
            icon: 'warning',
            title: 'Invalid Ticket ID',
            text: 'Ticket ID must be 12 characters long.',
          });
        }
      }
    };

  return (
    <>
    <div className="col-lg-8 col-md-12">
    <div
      className="p-4 shadow rounded-4"
      style={{ maxWidth: "520px", margin: "60px auto", background: "#fff" }}
    >
      {error && (
        <p className="text-danger mb-2">* Invalid Ticket ID</p>
      )}
      <Form onSubmit={handleSubmit}>
        {/* Search Bar */}
        {/* <InputGroup className="mb-4" style={boxStyle}>
          <Input
            type="text"
            placeholder="Search Ticket"
            className="border-0 py-2 px-3"
          />
          <Button color="primary" className="rounded-0 px-3">
            <FiSearch size={18} />
          </Button>
        </InputGroup> */}

        {/* Ticket + RF-ID */}
        <Row className="g-3 mb-3">
          <Col md="6">
            <div className="p-2" style={boxStyle}>
              <Input
                type="text"
                value={ticketNumber}
                onChange={(e) => bookingDetails(e.target.value)}
                placeholder="Enter Ticket ID"
                className="border-0 fw-semibold"
                required={true}
              />
            </div>
          </Col>
          <Col md="6">
            <div className="p-2" style={boxStyle}>
              {/* <Input
                type="select"
                value={rfid}
                onChange={(e) => setRfid(e.target.value)}
                className="border-0 fw-bold"
                required={true}
              >
                <option value="">Select RF-ID Card</option>
                {allrfid
                  .filter((item: any) => item.status === false)
                  .map((item: any) => (
                  <option key={item.rfid} value={item.rfId}>
                    {`RFID No ${item.rfidCardUniqueNumber}`}
                  </option>
                  ))}
              </Input> */}
              <Select
                options={options}
                value={options.find((opt) => opt.value === rfid) || null}
                onChange={(selectedOption) => setRfid(selectedOption?.value)}
                className="fw-bold"
                placeholder="Select RF-ID Card"
                isSearchable
                isClearable
              />
            </div>
          </Col>
          {/* <Col md="6">
            <div className="p-2" style={boxStyle}>
              <Input
                type="number"
                value={cardAmount}
                onChange={(e) => setCardAmount(Number(e.target.value))}
                placeholder="Enter amount"
                className="border-0 fw-semibold"
                required={true}
              />
            </div>
          </Col> */}
          <Col md="6">
            <div className="p-2" style={boxStyle}>
              <Input
              type="date"
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
              className="border-0 fw-semibold"
              min={new Date().toISOString().slice(0, 10)}
              max={new Date().toISOString().slice(0, 10)}
              />
            </div>
          </Col>
        </Row>

        {/* Assign Button */}
        <div className="text-center">
          <Button
            type="submit"
            color="primary"
            className="fw-semibold px-5 py-2 rounded-3"
            style={{ fontSize: "1.1rem" }}
            disabled={!rfidData}
          >
            Assign
          </Button>
        </div>
      </Form>
    </div>
    </div>
    {/* Ticket Details Column */}
    <div className="col-lg-4 col-md-12">
      <TicketDetails rfidData={rfidData} />
    </div>
    </>
  );
};

export default TicketAssignForm;
